import { Component, NgModule , OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef,
  OnChanges, TemplateRef, ViewChild, ChangeDetectorRef} from '@angular/core';
import {DemoService} from '../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';
import { MysqlService } from './../../../services/mysql.service';


import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpRequest, HttpResponse, HttpEvent } from '@angular/common/http';

// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import { Subscription } from 'rxjs';


import { FileUploaderService } from './../../../services/file-uploader-service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { GlobalFunctionsService } from './../../../services/global-functions.service';


import { SubjectInvoice } from './../../../shared/models/subjectInvoice.model';
import { SubjectInvoiceItem } from './../../../shared/models/subjectInvoiceItem.model';

@Component({
  selector: 'app-create-invoice-widget',
  templateUrl: './create-invoice-widget.component.html',
  styleUrls: ['./create-invoice-widget.component.css']
})
export class CreateInvoiceWidgetComponent implements OnInit {

     // setup as observable?
     @Input() item_id?: Observable<any[]>; // impliments on changes.
     @Input() item_data?: Observable<any[]>; // if data.model is sent : Observable<any[]>;
     @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
     @Input() item_user_level_id? = '5'; // default to agent just in case
     @Input() item_brand_type_id? = '';
     @Input() show_buttons? = 'no'; // yes | no
     @Input() widget_title? = '';
     @Input() widget_size? = 'side'; // side | abstract | full
  
     job: any;
     @Input() job_id; 
     @Input() subject_id; 
     @Input() subject_number?;
     @Input() job_number;
     @Input() is_job_invoice = 0;
     @Input() is_attach_method = 0;
   
   
    @Output('closeParentModel') closeParentModel: EventEmitter<any> = new EventEmitter();
 //   @Output('closeParentModel2') closeParentModel2: EventEmitter<any> = new EventEmitter();

     invoice_model: SubjectInvoice = new SubjectInvoice();
     invoice_item_model: any = SubjectInvoiceItem;
  brand_invoice_id: any;
  brand: any;
  invoice_brand: any;
  subject_billing_items: any;
  owner_brand: any;

  // holding array items;
  invoiceItemsList: any = [];
  invoiceItem: any = [];
  isShowEdit = false ; // hidden by default]
  isShow; // hidden by default
  invoice_total: any;
  invoice_tax: number;
  invoice_subtotal: number;
  invoice_job_type_id: any;
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  all_router_details: string;

  public today = Date.now();
  modalRef: BsModalRef;
  invoice_status_all: any;
  invoice_payment_status_all: any;
  invoice_communication_status_all: any;
  valueDatePickerDate
  valueDatePickerDate_due: Date;
  Date: Date;
  expanded = false;
  new_invoice_id: any;
  returned_invoice_id: any;
  subject: any;
  dateFormat: string;
  po_number: any;
  job_report_client_user: Object;
  report_user_contact_name: string;
  document_number: any;
  f_address: string;
  date_of_instructions: any;
  instructions_date: any;
  
    constructor(
      private http: HttpClient, private _demoService: DemoService,
      private route: ActivatedRoute, public toastr: HotToastService,
       vcr: ViewContainerRef, private router: Router,
       public HttpClient:HttpClient,
       private fileUploader: FileUploaderService,
       private _mysqlService: MysqlService,
       private modalService: BsModalService,
       public datepipe: DatePipe,
       public gfunc: GlobalFunctionsService,
       private cdr:ChangeDetectorRef // allows for change detection once pushed data to an array
    ) {
       // Set and Access login Session Variables
 this.gfunc.setLoginSessionVars(); // set in a global function file
 this.sessionUserId = this.gfunc.currentUserVAR.user_id;
 this.sessionUsername = this.gfunc.currentUserVAR.username;
 this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

      // need to add this as routes does not work globally
      this.all_router_details = this.router.url;
      this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));


      // automically set the new dat 30 dyas form today
// ::@https://stackoverflow.com/questions/44827066/add-30-days-to-a-current-date-js
const date = new Date(); // Now

// DEC 2022 Update Default to 14 Days
const new_date = date.setDate(date.getDate() + 14);
// const new_date = date.setDate(date.getDate() + 30);


// invoice_model.due_date = this.datepipe.transform(new_date, 'dd-MM-yy');
// this.dateFormat = 'dd/MM/yyyy hh:mm a'; // standard date format
this.dateFormat = 'd/M/y h:m a z'; // standard date format
// invoice_model.due_date = this.datepipe.transform(new_date, this.dateFormat);


   //   this.toastr.setRootViewContainerRef(vcr);
// Date picker date format
   this.valueDatePickerDate = new Date(this.today);
   this.valueDatePickerDate_due = new Date(new_date);
     }
  
     // check for changes. to load data.
     ngOnChanges(changes) {



  // this.invoice_model = new SubjectInvoice();
  this.invoice_item_model = new SubjectInvoiceItem();

  // :: Intruduction of Job Invoices.
  if (this.is_job_invoice == 1) {
    this.getJobBillingItems(this.job_id);
  }else {
    // this.getSubjectBillingItems(this.subject_id); // -- Changed so that this one only loads a new item and existin is a new fuction feb 2023
    this.getSubjectBillingItems_Existing(this.subject_id);
  }

  

  this.getJobSubject(this.subject_id);
  this.getJob(this.job_id);
  this.getInvoiceStatusAll();
  this.getInvoicePaymentStatusAll();
  this.getInvoiceCommunicationStatusAll();







if (changes.item_id) {
        // deal with asynchronous Observable result
      //  this.job_id = changes.item_id.currentValue;
        // this.getJob(this.job_id);
      }
    }
  
  
    ngOnInit() {
    }
  
    // Functions






    getJobSubject(subject_id) {
      this._demoService.getJobSubject(subject_id).subscribe(
        data => { this.subject = data;
          let res = data[0];
          this.subject_number = res.subject_number;
         // this.job_number = res.job_id + '.1'; // made up
         // console.log("Done loadng USER");

          // if (res.address_1 == undefined ){
          //   this.f_address = '';
          // }else{
          //   this.f_address = res.address_1 +  ' ' + res.address_2 +  ' ' + res.suburb +  ' ' + res.state +  ',  ' + res.postcode;
          // }
         

          if (!res.street_address){
            this.f_address = '';
          }else{
            this.f_address = res.street_address +  ' ' + res.suburb +  ' ' + res.state +  ',  ' + res.postcode;
          }

        },
        error => {
        //  console.error('Error Loading User!');
        // return Observable.throw(error);
        }
      ); }
 




  getJob(job_id) {
    this._demoService.getJobID(job_id).subscribe(
       data => { this.job = data;
        let res = data[0];
        // Run the job data queries.
      this.brand_invoice_id =  res.brand_invoice_id;
      this.invoice_job_type_id = res.job_type_id;
      this.getInvoiceBrand(res.brand_invoice_id);
      this.getOwnerBrand(94);
      // show the report user name on invoices 29/01/24
      this.getJobReportUser(res.brand_report_user_id)

      this.po_number = res.owner_trace_code;
      // this.invoice_model.po_number = this.po_number;

      this.document_number = res.document_number;
      this.instructions_date = res.instructions_date;

// setup the invoice holding data (this did NOT load the form data without running a ngfor statement)
  // Setup the SubjectInvoice
  // this.invoiceItem.push({
  //   invoice_number: this.subject_number,
  //   job_id: this.job_id,
  //   to_brand_id: this.brand_invoice_id,
  //   subject_id: this.subject_id,
  //   job_type_id: this.invoice_job_type_id,
  //   file_id: null,
  //   created_by: this.sessionUserId,
  // //  date_created: this.today,
  //   invoice_total: this.invoice_total,
  //   invoice_gst: this.invoice_tax,
  //   invoice_subtotal: this.invoice_subtotal,
  //   invoice_status_id: 1,
  //   invoice_payment_status_id: 1,
  //   invoice_communication_status_id: 1,
  //   from_brand_id: 94,
  // //  due_date: this.today,
  //   job_number: this.job_number,
  //         });




          this.invoiceItem = [{
            invoice_number: this.subject_number,
            job_id: this.job_id,
            to_brand_id: this.brand_invoice_id,
            subject_id: this.subject_id,
            job_type_id: this.invoice_job_type_id,
            file_id: null,
            created_by: this.sessionUserId,
            date_created: this.valueDatePickerDate,
            invoice_total: this.invoice_total,
            invoice_gst: this.invoice_tax,
            invoice_subtotal: this.invoice_subtotal,
            invoice_status_id: '1',
            invoice_payment_status_id: '1',
            invoice_communication_status_id: '1',
            from_brand_id: 94,
            due_date: this.valueDatePickerDate_due,
            job_number: this.job_number,
            subject_number: this.subject_number,
            po_number: this.po_number,
          }];

          this.invoice_model = this.invoiceItem;

          // :: In order to reflect the data changes on the template, you need to use detect changes, DID NOTHING!
          // ::: constructor(private cdr:ChangeDetectorRef) 
          // and apply the following once you push the data  
          // ::: this.cdr.detectChanges();
          this.cdr.detectChanges();

          this.doCalculations();
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }

   private getInvoiceBrand(brand_id) {
    this._demoService.getBrandById(brand_id).subscribe(
      (data) => {
        this.invoice_brand = data;
        let res = data[0];
      },
      (err) => console.error(err),
      () => console.log('Brand Loaded.')
    );
  }

  
  private getOwnerBrand(brand_id) {
    this._demoService.getBrandById(brand_id).subscribe(
      (data) => {
        this.owner_brand = data;
        let res = data[0];
      },
      (err) => console.error(err),
      () => console.log('Brand Loaded.')
    );
  }

  getInvoiceStatusAll(){
    this._demoService.getInvoiceStatusAll().subscribe(
      (data) => {
        this.invoice_status_all = data;
        let res = data[0];
      },
      (err) => console.error(err),
     // () => console.log('Brand Loaded.')
    );
  }

  getInvoicePaymentStatusAll(){
    this._demoService.getInvoicePaymentStatusAll().subscribe(
      (data) => {
        this.invoice_payment_status_all = data;
        let res = data[0];
      },
      (err) => console.error(err),
     // () => console.log('Brand Loaded.')
    );
  }


  getInvoiceCommunicationStatusAll(){
    this._demoService.getInvoiceCommunicationStatusAll().subscribe(
      (data) => {
        this.invoice_communication_status_all = data;
        let res = data[0];
      },
      (err) => console.error(err),
     // () => console.log('Brand Loaded.')
    );
  }


  // uses this one on create invoice add item... and ... auto add item so I think I need to fix... and make a new fuction for the auto add.
  getSubjectBillingItems(subject_id) {
    // empty array of invoiceItemsList first
    this.invoiceItemsList = [];
    this._demoService.getSubjectBillingItems(subject_id).subscribe(
      data => { this.subject_billing_items = data;

      let newArr = Object(data).filter((sbi)=>(sbi.invoice_status === 'NOT-INVOICED'));

      let  count_of_items = Object.keys(newArr).length;
     //  let res = data[0];
       // Run the job data queries.

       // need to do a loop of subject_billing items (.length)
       for(let i=0;i < count_of_items; i++) {
        let res = newArr[i];


            // Dont need
        // do some totals and tax calculations. 30/01/24

                 let tax_percent;
                 let tax_value = 0;
                //  let new_total = 0; // + GST
                let new_total = 0; // + GST
                  if(res.myob_tax_code_id == 1 || res.myob_tax_code_id == 4) {
                    tax_percent = 10;
                    // tax_value = (res.billing_task_fee / (100 / tax_percent));
                    // tax_value = (res.billing_task_fee / 11); // exclusive
                    tax_value = (res.billing_task_fee / (100 / tax_percent)); // + GST
                    // fix for two decimaal precicion for myob
                    let rounded_tax_value = Math.round((tax_value + Number.EPSILON) * 100) / 100;
                    tax_value = rounded_tax_value;
                    // tax_value = (res.billing_task_fee / 11); // exclusive
                   new_total = (+res.billing_task_fee + +tax_value); // + GST
                       let rounded_new_total = Math.round((new_total + Number.EPSILON) * 100) / 100;
                       new_total = rounded_new_total;
                  }



                  if(res.myob_tax_code_id >= 2  && res.myob_tax_code_id != 4) { /// anything else other than GST is all we neee no tax or free  // + GST
                    tax_percent = 0;
                    tax_value = 0;
                    new_total = res.billing_task_fee; // + GST
                
                  }
 
/*
   let rounded_data_tax = Math.round((this.row_data.tax + Number.EPSILON) * 100) / 100;
   this.row_data.tax = rounded_data_tax;
*/


// --- CHANGED THIS ONE ANYWAY BEAUSE ITS USED ELSEHWERE...

    // push to holding list of invoice items, all current subject_billing_items. (no filtering as yet.)
    // this.invoiceItemsList.push({
    //   invoice_number: res.job_number,
    //   billing_task_id: res.billing_task_id,
    //   subject_billing_item_id: res.subject_billing_item_id,
    //   billing_task_name: res.billing_task_name,
    //   myob_tax_code_id: res.myob_tax_code_id,
    //   myob_account_code_id: res.myob_account_code_id,
    //   billing_task_fee: res.billing_task_fee,
    //   billing_task_description: res.billing_task_description,
    //   subject_id: res.subject_id,
    //   subject_number: res.subject_number,
    //   job_id: res.job_id,
    //   job_number: res.job_number,
    //   qty: 1,
    //   unit_price: res.billing_task_fee,
    //   tax: tax_value,
    //   total: +res.billing_task_fee + +tax_value
    //   // tslint:disable-next-line:max-line-length
    //   // total: new_total, // + GST // was not adding correctly do do not use..?????? (fix you need to add +variable to the start of the variable to add in typescrupt!)
    //   // total: (+res.billing_task_fee + +tax_value), // + GST
    //   // total: res.billing_task_fee,
    //         });
  
        // push to holding list of invoice items, all current subject_billing_items. (no filtering as yet.)
                   this.invoiceItemsList.push({
            invoice_number: res.invoice_number,
            billing_task_id: res.billing_task_id,
            subject_billing_item_id: res.subject_billing_item_id,
            billing_task_name: res.billing_task_name,
            myob_tax_code_id: res.myob_tax_code_id,
            myob_account_code_id: res.myob_account_code_id,
            billing_task_fee: res.billing_task_fee,
            billing_task_description: res.billing_task_description,
            subject_id: res.subject_id,
            subject_number: res.subject_number,
            job_id: res.job_id,
            job_number: res.job_number,
            qty: res.qty,
            unit_price: res.billing_task_fee,
            tax: res.tax,
            total: res.total
            // tslint:disable-next-line:max-line-length
            // total: new_total, // + GST // was not adding correctly do do not use..?????? (fix you need to add +variable to the start of the variable to add in typescrupt!)
            // total: (+res.billing_task_fee + +tax_value), // + GST
            // total: res.billing_task_fee,
                  });


      this.invoiceItemsList = this.invoiceItemsList;










// this.invoiceItemsList = [{
//   invoice_number: res.job_number,
//   billing_task_id: res.billing_task_id,
//   subject_billing_item_id: res.subject_billing_item_id,
//   billing_task_name: res.billing_task_name,
//   myob_tax_code_id: res.myob_tax_code_id,
//   myob_account_code_id: res.myob_account_code_id,
//   billing_task_fee: res.billing_task_fee,
//   billing_task_description: res.billing_task_description,
//   subject_id: res.subject_id,
//   subject_number: res.subject_number,
//   job_id: res.job_id,
//   job_number: res.job_number,
//   qty: 1,
//   unit_price: res.billing_task_fee,
//   tax: tax_value,
//   total: res.billing_task_fee,
//         }];

    } // end for loop count

  // do some global calculations
// get sum of msgCount prop across all objects in array
// gets fee * qty adds them all up
// this.invoice_total = this.invoiceItemsList.reduce((acc, val) => acc += (val.billing_task_fee * val.qty ), 0);
this.doCalculations();

     },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }


  getSubjectBillingItems_Existing(subject_id) {
    // empty array of invoiceItemsList first
    this.invoiceItemsList = [];
    this._demoService.getSubjectBillingItems(subject_id).subscribe(
      data => { this.subject_billing_items = data;

      let newArr = Object(data).filter((sbi)=>(sbi.invoice_status === 'NOT-INVOICED'));

      let  count_of_items = Object.keys(newArr).length;
     //  let res = data[0];
       // Run the job data queries.

       // need to do a loop of subject_billing items (.length)
       for(let i=0;i < count_of_items; i++) {
        let res = newArr[i];


            // Dont need
        // do some totals and tax calculations.

                //  let tax_percent;
                //  let tax_value = 0;
                // //  let new_total = 0; // + GST
                // let new_total = 0; // + GST
                //   if(res.myob_tax_code_id == 1) {
                //     tax_percent = 10;
                //     // tax_value = (res.billing_task_fee / (100 / tax_percent));
                //     // tax_value = (res.billing_task_fee / 11); // exclusive
                //     tax_value = (res.billing_task_fee / (100 / tax_percent)); // + GST
                //     // fix for two decimaal precicion for myob
                //     let rounded_tax_value = Math.round((tax_value + Number.EPSILON) * 100) / 100;
                //     tax_value = rounded_tax_value;
                //     // tax_value = (res.billing_task_fee / 11); // exclusive
                //    new_total = (+res.billing_task_fee + +tax_value); // + GST
                //        let rounded_new_total = Math.round((new_total + Number.EPSILON) * 100) / 100;
                //        new_total = rounded_new_total;
                //   }
                //   if(res.myob_tax_code_id >= 2) { /// anything else other than GST is all we neee no tax or free  // + GST
                //     tax_percent = 0;
                //     tax_value = 0;
                //     new_total = res.billing_task_fee; // + GST
                
                //   }
 
/*
   let rounded_data_tax = Math.round((this.row_data.tax + Number.EPSILON) * 100) / 100;
   this.row_data.tax = rounded_data_tax;
*/



    // push to holding list of invoice items, all current subject_billing_items. (no filtering as yet.)
    // this.invoiceItemsList.push({
    //   invoice_number: res.job_number,
    //   billing_task_id: res.billing_task_id,
    //   subject_billing_item_id: res.subject_billing_item_id,
    //   billing_task_name: res.billing_task_name,
    //   myob_tax_code_id: res.myob_tax_code_id,
    //   myob_account_code_id: res.myob_account_code_id,
    //   billing_task_fee: res.billing_task_fee,
    //   billing_task_description: res.billing_task_description,
    //   subject_id: res.subject_id,
    //   subject_number: res.subject_number,
    //   job_id: res.job_id,
    //   job_number: res.job_number,
    //   qty: 1,
    //   unit_price: res.billing_task_fee,
    //   tax: tax_value,
    //   total: +res.billing_task_fee + +tax_value
    //   // tslint:disable-next-line:max-line-length
    //   // total: new_total, // + GST // was not adding correctly do do not use..?????? (fix you need to add +variable to the start of the variable to add in typescrupt!)
    //   // total: (+res.billing_task_fee + +tax_value), // + GST
    //   // total: res.billing_task_fee,
    //         });
  
        // push to holding list of invoice items, all current subject_billing_items. (no filtering as yet.)
                   this.invoiceItemsList.push({
            invoice_number: res.invoice_number,
            billing_task_id: res.billing_task_id,
            subject_billing_item_id: res.subject_billing_item_id,
            billing_task_name: res.billing_task_name,
            myob_tax_code_id: res.myob_tax_code_id,
            myob_account_code_id: res.myob_account_code_id,
            billing_task_fee: res.billing_task_fee,
            billing_task_description: res.billing_task_description,
            subject_id: res.subject_id,
            subject_number: res.subject_number,
            job_id: res.job_id,
            job_number: res.job_number,
            qty: res.qty,
            unit_price: res.billing_task_fee,
            tax: res.tax,
            total: res.total
            // tslint:disable-next-line:max-line-length
            // total: new_total, // + GST // was not adding correctly do do not use..?????? (fix you need to add +variable to the start of the variable to add in typescrupt!)
            // total: (+res.billing_task_fee + +tax_value), // + GST
            // total: res.billing_task_fee,
                  });


      this.invoiceItemsList = this.invoiceItemsList;










// this.invoiceItemsList = [{
//   invoice_number: res.job_number,
//   billing_task_id: res.billing_task_id,
//   subject_billing_item_id: res.subject_billing_item_id,
//   billing_task_name: res.billing_task_name,
//   myob_tax_code_id: res.myob_tax_code_id,
//   myob_account_code_id: res.myob_account_code_id,
//   billing_task_fee: res.billing_task_fee,
//   billing_task_description: res.billing_task_description,
//   subject_id: res.subject_id,
//   subject_number: res.subject_number,
//   job_id: res.job_id,
//   job_number: res.job_number,
//   qty: 1,
//   unit_price: res.billing_task_fee,
//   tax: tax_value,
//   total: res.billing_task_fee,
//         }];

    } // end for loop count

  // do some global calculations
// get sum of msgCount prop across all objects in array
// gets fee * qty adds them all up
// this.invoice_total = this.invoiceItemsList.reduce((acc, val) => acc += (val.billing_task_fee * val.qty ), 0);
this.doCalculations();

     },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }


// Need to upgrade billing items to calculate for Nijo Dream Items As Well. --- Job Billing Items... Th is probably where things go weird with totals.
// :: Job Inoive Items Gathers all items
  getJobBillingItems(job_id) {
    // empty array of invoiceItemsList first
    this.invoiceItemsList = [];
    this._demoService.getJobBillingItems(job_id).subscribe(
      // :: use the same array to keep everything consistant
      data => { this.subject_billing_items = data;

      let newArr = Object(data).filter((sbi)=>(sbi.invoice_status === 'NOT-INVOICED'));

      let  count_of_items = Object.keys(newArr).length;
     //  let res = data[0];
       // Run the job data queries.

       // need to do a loop of subject_billing items (.length)
       for(let i=0;i < count_of_items; i++) {
        let res = newArr[i];
  // do some totals and tax calculations.

 let tax_percent;
 let tax_value = 0;
//  res.total =  res.billing_task_fee; // set as default;
// 20/01/24 -- missing qty
// res.total =  res.billing_task_fee * res.qty; // this line of code stuffed up the row totatls on creation!!!!!! DO NOT USE ALSO WRONG FIGURE

  if(res.myob_tax_code_id == 1 || res.myob_tax_code_id == 4 ) {
    tax_percent = 10;
        tax_value = (res.billing_task_fee / (100 / tax_percent)); // + GST
        // tax_value = (res.billing_task_fee / 11); // exclusive
        // res.total =  res.billing_task_fee + tax_value; // + GST
            // fix for two decimaal precicion for myob
    let rounded_tax_value = Math.round((tax_value + Number.EPSILON) * 100) / 100;
    tax_value = rounded_tax_value;
    // tax_value = (res.billing_task_fee / 11); // exclusive
  //  new_total = (+res.billing_task_fee + +tax_value); // + GST
  //  let rounded_new_total = Math.round((new_total + Number.EPSILON) * 100) / 100;
  //  new_total = rounded_new_total;
        
        
  }
  if(res.myob_tax_code_id !== 2 || res.myob_tax_code_id != '4' ) {
    tax_percent = 0;
    tax_value = 0;
  }
 
  
//         // push to holding list of invoice items, all current subject_billing_items. (no filtering as yet.)
//        this.invoiceItemsList.push({
// invoice_number: res.invoice_number,
// billing_task_id: res.billing_task_id,
// subject_billing_item_id: res.subject_billing_item_id,
// billing_task_name: res.billing_task_name,
// myob_tax_code_id: res.myob_tax_code_id,
// myob_account_code_id: res.myob_account_code_id,
// billing_task_fee: res.billing_task_fee,
// billing_task_description: res.billing_task_description,
// subject_id: res.subject_id,
// subject_number: res.subject_number,
// job_id: res.job_id,
// job_number: res.job_number,
// qty: 1,
// unit_price: res.billing_task_fee,
// tax: tax_value,
// total: +res.billing_task_fee + +tax_value,
// // total: res.total,

//       });


    /// 2023 update to get existing items datas instead.
        // push to holding list of invoice items, all current subject_billing_items. (no filtering as yet.)
        this.invoiceItemsList.push({
          invoice_number: res.invoice_number,
          billing_task_id: res.billing_task_id,
          subject_billing_item_id: res.subject_billing_item_id,
          billing_task_name: res.billing_task_name,
          myob_tax_code_id: res.myob_tax_code_id,
          myob_account_code_id: res.myob_account_code_id,
          billing_task_fee: res.billing_task_fee,
          billing_task_description: res.billing_task_description,
          subject_id: res.subject_id,
          subject_number: res.subject_number,
          job_id: res.job_id,
          job_number: res.job_number,
          qty: res.qty,
          unit_price: res.billing_task_fee,
          tax: res.tax,
          total: res.total
          // tslint:disable-next-line:max-line-length
          // total: new_total, // + GST // was not adding correctly do do not use..?????? (fix you need to add +variable to the start of the variable to add in typescrupt!)
          // total: (+res.billing_task_fee + +tax_value), // + GST
          // total: res.billing_task_fee,
                });


      this.invoiceItemsList = this.invoiceItemsList;

    } // end for loop count
  // do some global calculations
// get sum of msgCount prop across all objects in array
// gets fee * qty adds them all up
// this.invoice_total = this.invoiceItemsList.reduce((acc, val) => acc += (val.billing_task_fee * val.qty ), 0);
this.doCalculations();

     },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }









// :: thus function creats both job and subject invoices.
  createSubjectInvoice(invoice_model) {

// invoice_model = [invoice_model]; // see if I can trick to make an object from form values missing brackets [{}]
// // :: need to add the [0] for #formname.value inserts.
// console.log(invoice_model);
//     this._demoService.createSubjectInvoice(invoice_model[0]).subscribe(
//        data => {  this.new_invoice_id = data;
//         let res = data[0];
//         // Run the insert of insert objects through a loop.
//         // let invoice_id = res.last_insert_id;

//         // console.log('InvoiceID: ' + invoice_id);

//         this.toastr.success('Invoice Entered');
//         this.closeParentModel.emit();
//       },
//        err => console.error(err),
//        // () => console.log('done loading Trace Types')
//      );

// automically set the new dat 30 dyas form today
// ::@https://stackoverflow.com/questions/44827066/add-30-days-to-a-current-date-js
const date = new Date(); // Now
const new_date = date.setDate(date.getDate() + 30);
// invoice_model.due_date = this.datepipe.transform(new_date, 'dd-MM-yy');
// this.dateFormat = 'dd/MM/yyyy hh:mm a'; // standard date format
this.dateFormat = 'd/M/y h:m a z'; // standard date format
// invoice_model.due_date = this.datepipe.transform(new_date, this.dateFormat);


// Need to lup the po_number from the job.


    invoice_model.is_job_invoice = this.is_job_invoice;
    invoice_model.is_encrypted = 0;
     this._demoService.createSubjectInvoice(invoice_model).subscribe(
      data => {  this.new_invoice_id = data; // this is the retuned json upon creation.

        let res = data[0];
                // Run the insert of insert objects through a loop.
                this.returned_invoice_id = this.new_invoice_id.last_insert_id;
                console.log(this.returned_invoice_id);

// now inset the items
let  count_of_items = Object.keys(this.invoiceItemsList).length;
  // need to do a loop of subject_billing items (.length)
  for(let i=0; i < count_of_items; i++) {
   let invoiceData = this.invoiceItemsList[i];
   // :: add the items
   this.addSubjectInvoiceItem(invoiceData, this.returned_invoice_id);
// :: TODO need to update subjectBillingItem, as status invoiced.
let invoice_status = "INVOICED";
// tslint:disable-next-line:max-line-length

this.updateSubjectBillingItemInvoiceStatus(invoice_status, invoiceData.subject_billing_item_id, this.returned_invoice_id, this.subject_number, invoiceData);
  } // end for

this.gfunc.insertLog_CreateInvoice(invoice_model);

this.gfunc.insertNote_CreateInvoice(invoice_model);

        this.toastr.success('Invoice Entered');
        this.closeParentModel.emit();
        this.refreshSujectInvoicePage(this.subject_id);
      // this.router.navigate(['../../companies'], { relativeTo: this.route });
       return true;
      },
      error => {
        console.error(error);
        this.toastr.error('Adding Failed :: Please try again!');
       // console.log(Observable.throw(error));
        // return Observable.throw(error);
      }
 )
};



   addSubjectInvoiceItem(model, invoice_id){
    this._demoService.addSubjectInvoiceItem(model, invoice_id).subscribe(
      data => {  // this.new_invoice_id = data; // this is the retuned json upon creation.
        // let res = data[0];
      // this.router.navigate(['../../companies'], { relativeTo: this.route });
       return true;
      },
      error => {
        console.error(error);
     //  this.toastr.error('Adding Failed :: Please try again!');
       // console.log(Observable.throw(error));
        // return Observable.throw(error);
      }
 )
   }



   updateSubjectBillingItemInvoiceStatus(invoice_status, subject_billing_item_id, invoice_id,invoice_number, invoice_model){
    this._demoService.updateSubjectBillingItemInvoiceStatus(invoice_status, subject_billing_item_id, invoice_id, invoice_number, invoice_model).subscribe(
      data => {  // this.new_invoice_id = data; // this is the retuned json upon creation.
        // let res = data[0];
      // this.router.navigate(['../../companies'], { relativeTo: this.route });
       return true;
      },
      error => {
        console.error(error);
     //  this.toastr.error('Adding Failed :: Please try again!');
       // console.log(Observable.throw(error));
        // return Observable.throw(error);
      }
 )
   };







//  New Function Working August 2022 = + GST
doCalculations() {

  // this.invoice_tax = this.invoiceItemsList.reduce((a, b) => a += (b.tax), 0); // now calculates !!!!!! NUMBER FORMAT MISSING>>>>>
this.invoice_tax = this.invoiceItemsList.reduce((a, b) => a += Number(b.tax), 0); // now calculates
  this.invoice_model.invoice_gst = this.invoice_tax;

  // this.toastr.info('Calculating...');
  this.invoice_total = this.invoiceItemsList.reduce((a, b) => a += (b.billing_task_fee * b.qty), 0);
  
  // 30/01/24 this was wron the invoice total was removing the tax...
  this.invoice_model.invoice_total = this.invoice_total + this.invoice_tax;


  this.invoice_subtotal = (this.invoice_total); // dont take the tax!
  this.invoice_model.invoice_subtotal = this.invoice_subtotal;

  this.invoice_model = this.invoiceItem;
 // 

}







// can also run from a child component.
doCalculations_() {

//  this.invoice_tax = (this.invoice_model.invoice_total / (100 / 10));
// this.invoice_tax = this.invoiceItemsList.reduce((a, b) => a += (b.tax * b.qty), 0); // now calculates

//  this.invoice_tax = this.invoiceItemsList.reduce((a, b) => a += (b.tax), 0); // now calculates invlusive (current)

this.invoice_tax = this.invoiceItemsList.reduce((a, b) => a += (b.tax), 0); // with qty for tax + GST 
this.invoice_model.invoice_gst = this.invoice_tax;
  // this.invoice_subtotal = (this.invoice_model.invoice_total - this.invoice_tax); // Plus GST
 // :: Invoice Subtotal does not need tax removed as it is always inclusive in the price



  
  // this.toastr.info('Calculating...'); // moved belwo calculations
  this.invoice_total = this.invoiceItemsList.reduce((a, b) => a += (b.billing_task_fee * b.qty), 0);
  // this.invoice_model.invoice_total = this.invoice_total; // includisve
  this.invoice_model.invoice_total = this.invoice_total + this.invoice_tax;


  //  this.invoice_subtotal = (this.invoice_model.invoice_total); // icusive
this.invoice_subtotal = (this.invoice_model.invoice_total - this.invoice_tax);
this.invoice_model.invoice_subtotal = this.invoice_subtotal;

  this.invoice_model = this.invoiceItem;
 // alert('test');
}


toggleShow(index) {
 // this.isShowEdit = ! this.isShowEdit;
// if (this.isShow === index){
// this.isShow = '';
// }else{
//   this.isShow = index; // sets to the array row.d
// }
this.isShow = index; // sets to the array row.d

  }

  toggleHide(index) {
 // this.isShowEdit = ! this.isShowEdit;
// if (this.isShow === index){
// this.isShow = '';
// }else{
//   this.isShow = index; // sets to the array row.d
// }
this.isShow = index; // sets to the array row.d

  }



 // MODAL
// start of modal windows service as a template
openModal(template: TemplateRef<any>) {
  // small upgrade to disable background click on open modal background
  const config = { backdrop: true, ignoreBackdropClick: true, class: 'gray modal-lg' };
  this.modalRef = this.modalService.show(template, config);
}



// :: Parent / Child modal test
closeParentModel2() {
 //  alert('parent component function.');
   this.modalRef.hide();
// now refresh the invoice items list from the new items.
    // empty your array first
    this.invoiceItemsList.length = 0;
this.getSubjectBillingItems(this.subject_id);


 // this.closeParentModel.emit(); // ?shuts invoice window
 // this.refreshGrid(); // resets the grid if updated and closed.
//  this.updateTypeClick = false; // closes the div
};

RemoveElementFromObjectArray(key: number) {
  let data = this.invoiceItemsList;
      // data.forEach((value, index) => {
      //   if ( value.subject_billing_item_id === key) {
      //     this.row_data.splice(index, 1); }
      // });
      data.forEach((value,index)=>{
        if(value.subject_billing_item_id==key) data.splice(index,1);
    });

// do I need to refesh like adding?
this.doCalculations();

     };



     refreshSujectInvoicePage(subject_id){

      // this.router.navigateByUrl('admin/clients', {skipLocationChange: true}).then(() =>
      //               this.router.navigate(['/admin/jobs/subject/billing/' + subject_id + '']));
      this.gfunc.globalJobSubjectBillingViewSkipRoute(subject_id);

    }



      // show the report user name on invoices 29/01/24
      getJobReportUser(brand_report_user_id) {
        this._demoService.getUsersById(brand_report_user_id).subscribe(
           data => { 
                this.job_report_client_user = data;
    
                this.report_user_contact_name = this.job_report_client_user[0].first_name + ' ' + this.job_report_client_user[0].surname;
    
          },
           err => console.error(err),
           // () => console.log('done loading Trace Types')
         );
       }
    


  
  }

// Allows formatting of dates etc...
export class DatePipeComponent {
  today: number = Date.now();
  fixedTimezone = '2018-04-11T09:03:01+1000'; // Fixed to Brisbane Australia
// tslint:disable-next-line:eofline
}